import { useState } from 'react';
import FilePreviewModal from './FilePreviewModal';
import { previewTarget } from '../../utils/documentPreview';

// A document's link that opens it in the in-app viewer rather than a new tab,
// when the viewer can reach it (a file stored in Ops, or a SharePoint file on
// a record: see utils/documentPreview.js). Otherwise it is the plain link it
// always was. Ctrl or Cmd-click still opens the original in a new tab.
//
//   <DocumentLink kind="bid" id={doc.id} url={doc.url} filename={doc.filename}
//                 title={doc.title} className="...">{doc.title}</DocumentLink>
export default function DocumentLink({ kind, id, url, filename, title, className, children, linkTitle }) {
  const [open, setOpen] = useState(false);
  const target = previewTarget({ kind, id, url, filename, title });

  if (!target) {
    return <a href={url} target="_blank" rel="noopener noreferrer" className={className} title={linkTitle}>{children}</a>;
  }
  const onClick = (e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // the browser's own new tab
    e.preventDefault();
    setOpen(true);
  };
  return (
    <>
      <a href={target.openUrl || url} target="_blank" rel="noopener noreferrer" onClick={onClick}
        className={className} title={linkTitle || 'View in Ops'}>{children}</a>
      {open && (
        <FilePreviewModal url={target.url} filename={target.filename} title={title}
          openUrl={target.openUrl} onClose={() => setOpen(false)} />
      )}
    </>
  );
}
